var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBrightness = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2",
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Brightness_Sun",
  "data-name": "Brightness, Sun"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m10,4c-.55,0-1-.45-1-1V1c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m10,20c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m19,11h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m3,11H1c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m10,4c-.55,0-1-.45-1-1V1c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m10,20c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m19,11h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m3,11H1c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m14.95,6.05c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l1.41-1.41c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.41,1.41c-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m3.64,17.36c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l1.41-1.41c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.41,1.41c-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m16.36,17.36c-.26,0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.41,1.41c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m5.05,6.05c-.26,0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.41,1.41c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m14.95,6.05c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l1.41-1.41c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.41,1.41c-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m3.64,17.36c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l1.41-1.41c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.41,1.41c-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m16.36,17.36c-.26,0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.41,1.41c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m5.05,6.05c-.26,0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.41,1.41c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m10,15c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5Zm0-8c-1.65,0-3,1.35-3,3s1.35,3,3,3,3-1.35,3-3-1.35-3-3-3Z"
})))));
export default SvgIconBrightness;